module.exports = __webpack_public_path__ + "img/icon_ar.35c33d8b.png";